import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { c as _c } from "react-compiler-runtime";
import React, { useState } from 'react';
import { RemoteComponent } from '@nike/remote-component';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import useFetchShipOfferings from '@nike/shop-apis/buy/fulfillment_offerings/v1/fetch-ship-offerings/use-query';
import useFetchIdentityUserAddress from '@nike/shop-apis/identity/user/v1/address/use-query';
import { selectPreferredAddress } from '@nike/shop-apis/identity/user/v1/address/select';
import useRetailMFEStore from '@nike/shop-apis/store/retail-mfe/use-store';
import { EDD_Item, ShippingOptionsCopy, RemoteComponentLoadWrapper, StyledHeader } from './styles';
import ArrivesDate from './ArrivesDate';
import ShipOfferingsHeaderMessage from "../ship-offerings-header-message/ShipOfferingsHeaderMessage";
import { LoadingIndicator, LoadingIcon } from "../LoadingIndicator";
import getWebShellClientLocale from "../../../state/redux-replacement/get-webshellclient-locale";
import useShopDialogStore from "../../../store/shop-dialog/use-store";
var EDDContent = function EDDContent() {
  var $ = _c(27);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = getWebShellClientLocale();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var _t = t0,
    country = _t.country;
  var _useRetailMFEStore = useRetailMFEStore(_temp),
    retailMFEPostalCode_0 = _useRetailMFEStore.retailMFEPostalCode,
    setLocationSearch_0 = _useRetailMFEStore.setLocationSearch;
  var t1 = !retailMFEPostalCode_0;
  var t2;
  if ($[1] !== t1) {
    t2 = {
      select: selectPreferredAddress,
      enabled: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  var _useFetchIdentityUser = useFetchIdentityUserAddress(t2),
    t3 = _useFetchIdentityUser.data,
    isIdentityPostalCodeFetching = _useFetchIdentityUser.isFetching;
  var t4;
  if ($[3] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  var _t2 = t4,
    identityUserPostalCode = _t2.code;
  var isWaitingForIdentityData = !retailMFEPostalCode_0 && !identityUserPostalCode && isIdentityPostalCodeFetching;
  var postalCode = retailMFEPostalCode_0 || identityUserPostalCode;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isGeolocationSearching = _useState2[0],
    setIsGeolocationSearching = _useState2[1];
  var skuId = useShopDialogStore(_temp2);
  var t5 = !isIdentityPostalCodeFetching;
  var t6;
  if ($[5] !== postalCode || $[6] !== skuId || $[7] !== t5) {
    t6 = {
      skuId: skuId,
      postalCode: postalCode,
      enabled: t5,
      select: _temp4
    };
    $[5] = postalCode;
    $[6] = skuId;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  var _useFetchShipOffering = useFetchShipOfferings(t6),
    shipOfferings_0 = _useFetchShipOffering.data,
    isShipOfferingsLoading = _useFetchShipOffering.isLoading;
  var t7;
  if ($[9] === Symbol["for"]("react.memo_cache_sentinel")) {
    t7 = {
      stringKey: "shippingOptionsCopy",
      primaryValue: "All prices and dates are subject to change. Actual shipping options will be calculated during checkout.",
      description: "Message to users regarding shipping option dates and prices"
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  var shippingOptionsCopy = useI18nString(t7);
  var t8;
  if ($[10] !== setLocationSearch_0) {
    t8 = function t8(args) {
      setLocationSearch_0(args);
    };
    $[10] = setLocationSearch_0;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  var t10;
  var t9;
  if ($[12] === Symbol["for"]("react.memo_cache_sentinel")) {
    t9 = function t9() {
      return setIsGeolocationSearching(true);
    };
    t10 = function t10() {
      return setIsGeolocationSearching(false);
    };
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  var t11;
  if ($[14] !== t8) {
    t11 = /*#__PURE__*/React.createElement(RemoteComponentLoadWrapper, {
      "data-automation": "EDD-modal"
    }, /*#__PURE__*/React.createElement(RemoteComponent, {
      endpoint: "https://www.nike.com/fragments/location-search",
      FallbackComponent: LoadingIcon,
      prefetch: false,
      onDetailedSubmit: t8,
      limitToCountries: country,
      coldState: "message",
      onGeolocating: t9,
      onGeolocationChange: t10
    }));
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  var t12;
  if ($[16] !== isGeolocationSearching || $[17] !== isShipOfferingsLoading || $[18] !== isWaitingForIdentityData || $[19] !== shipOfferings_0) {
    t12 = isShipOfferingsLoading || isWaitingForIdentityData || isGeolocationSearching ? /*#__PURE__*/React.createElement(LoadingIndicator, null) : (shipOfferings_0 === null || shipOfferings_0 === void 0 ? void 0 : shipOfferings_0.map(_temp5)) || null;
    $[16] = isGeolocationSearching;
    $[17] = isShipOfferingsLoading;
    $[18] = isWaitingForIdentityData;
    $[19] = shipOfferings_0;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  var t13;
  if ($[21] !== shippingOptionsCopy) {
    t13 = /*#__PURE__*/React.createElement(ShippingOptionsCopy, null, shippingOptionsCopy);
    $[21] = shippingOptionsCopy;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  var t14;
  if ($[23] !== t11 || $[24] !== t12 || $[25] !== t13) {
    t14 = /*#__PURE__*/React.createElement(React.Fragment, null, t11, t12, t13);
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};
export default EDDContent;
function _temp(t0) {
  var t1 = t0.locationSearch,
    setLocationSearch = t0.setLocationSearch;
  var retailMFEPostalCode = t1.postCode;
  return {
    retailMFEPostalCode: retailMFEPostalCode,
    setLocationSearch: setLocationSearch
  };
}
function _temp2(state) {
  return state.skuId;
}
function _temp3(shipOffering) {
  var _shipOffering$getBy, _shipOffering$getBy2, _shipOffering$price, _shipOffering$getBy3;
  var minDate = (_shipOffering$getBy = shipOffering.getBy) === null || _shipOffering$getBy === void 0 || (_shipOffering$getBy = _shipOffering$getBy.minDate) === null || _shipOffering$getBy === void 0 ? void 0 : _shipOffering$getBy.dateTime;
  var maxDate = (_shipOffering$getBy2 = shipOffering.getBy) === null || _shipOffering$getBy2 === void 0 || (_shipOffering$getBy2 = _shipOffering$getBy2.maxDate) === null || _shipOffering$getBy2 === void 0 ? void 0 : _shipOffering$getBy2.dateTime;
  var price = (_shipOffering$price = shipOffering.price) === null || _shipOffering$price === void 0 ? void 0 : _shipOffering$price.total;
  var timezone = (_shipOffering$getBy3 = shipOffering.getBy) === null || _shipOffering$getBy3 === void 0 || (_shipOffering$getBy3 = _shipOffering$getBy3.maxDate) === null || _shipOffering$getBy3 === void 0 ? void 0 : _shipOffering$getBy3.timezone;
  return {
    minShipDate: minDate,
    maxShipDate: maxDate,
    timeZone: timezone,
    price: price
  };
}
function _temp4(foffsResponse) {
  var shipOfferings = foffsResponse.items[0].fulfillmentOfferings;
  return shipOfferings.map(_temp3);
}
function _temp5(t0, i) {
  var minShipDate = t0.minShipDate,
    maxShipDate = t0.maxShipDate,
    price_0 = t0.price,
    timeZone = t0.timeZone;
  return /*#__PURE__*/React.createElement(EDD_Item, {
    key: "offer-price-".concat(i, "-").concat(price_0)
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledHeader, {
    className: "shipping-pickup header"
  }, /*#__PURE__*/React.createElement(ShipOfferingsHeaderMessage, {
    price: price_0
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ArrivesDate, {
    className: "shipping-pickup arrives-date",
    minShipDate: minShipDate,
    maxShipDate: maxShipDate,
    timeZone: timeZone
  }))));
}